<template>
    <div class="p-3">
        <button class="d-flex flex-row gx-4px border-0 bg-white" @click="handleGoBack">
            <img src="@/assets/icons/arrow-back.png" />
            <div class="arrow-button">INDIETRO</div>
        </button>

        <div class="d-flex flex-col w-100">
            <div class="d-flex flex-row w-100">
                <h1 class="text-title">Itinerari</h1>
                <div class="ml-auto d-flex flex-row gap-16px">
                    <ButtonComponent text="SALVA" type="regular" class="bg-white" :isDisable="false"
                        @handleClick="() => handleEdit(status === 'DRAFT' ? 'DRAFT' : 'PUBLISHED')" />
                    <ButtonComponent v-if="userRole === 'admin' && !markedPath" class="bg-primary-custom"
                        :text="status === 'DRAFT' ? 'Pubblica itinerario' : 'RIMUOVI PUBBLICAZIONE'" type="primary"
                        @handleClick="() => handleEdit(status === 'DRAFT' ? 'PUBLISHED' : 'DRAFT')" />
                </div>
            </div>
        </div>
        <div>
            <p class="text-overview">{{ published }} itinerari pubblicati su {{ totals }} presenti</p>
        </div>
        <div class="mt-48px d-flex flex-row gap-16px ">
            <div class="create-route-panel-body flex-1 ">
                <div class="d-flex flex-row gap-16px w-100">
                    <InputComponent :title="titleMap[langCode].title" :max-number="50"
                        :text="textVar[titleMap[langCode].index].value" :placeholder="titleMap[langCode].placeholder"
                        :language="langCode" @handleText="handleTitle" />
                    <InputComponent :title="subtitleMap[langCode].title" :max-number="50"
                        :text="textVar[subtitleMap[langCode].index].value"
                        :placeholder="subtitleMap[langCode].placeholder" :language="langCode"
                        @handleText="handleSubTitle" />
                </div>
                <div class="d-flex flex-row gap-16px w-100">
                    <TextAreaComponent :title="practicabilityMap[langCode].title" :max-number="500" :rows="4"
                        :placeholder="practicabilityMap[langCode].placeholder" :language="langCode"
                        :text="textVar[practicabilityMap[langCode].index].value" @handleText="handlePracticability" />
                    <TextAreaComponent :title="durationMap[langCode].title" :max-number="500" :rows="4"
                        :placeholder="durationMap[langCode].placeholder" :language="langCode"
                        :text="textVar[durationMap[langCode].index].value" @handleText="handleDuration" />
                </div>
                <div class="d-flex flex-row gap-16px w-100">
                    <div class="flex-1">
                        <TextAreaComponent :title="descriptionMap[langCode].title" :max-number="2000" :rows="8"
                            :placeholder="descriptionMap[langCode].placeholder" :language="langCode"
                            :text="textVar[descriptionMap[langCode].index].value" @handleText="handleDescription" />
                    </div>
                    <div class="flex-1 w-50">
                        <ImgUploadComponent :token="token" :baseUrl="props.baseUrl" :initImages="imagesData"
                            @handleUpload="handleUpload" />
                    </div>
                </div>
                <div class="d-flex flex-row gap-16px w-100">
                    <div class="flex-1">
                        <CheckerComponent title="Ticketing" label="L'itinerario prevede l'acquisto di un biglietto"
                            @handleCheck="handleTicket" :isChecked="ticketRequired" />
                        <CheckerComponent v-show="userRole === 'admin' && status === 'PUBLISHED'" title="In evidenza"
                            label="Metti l'itinerario “In evidenza”" @handleCheck="handleMarkedPath"
                            :isChecked="markedPath" />
                    </div>
                    <div class="flex-1" :class="{ 'disabled-state': userRole !== 'admin' }">
                        <PremialitaComponent :key="activities.length" :activities="activities" :baseUrl="props.baseUrl"
                            :token="token" :itineraryId="props.editorId" @onUpdate="fetchDataById" />
                    </div>
                </div>
                <div class="w-50 gap-8px">
                    <div class="title-input">
                        Seleziona il raggruppamento inerente all'itinerario
                    </div>
                    <div v-if="isLoading">
                        <Loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" color="#2D489D"
                            loader="dots"></Loading>
                    </div>
                    <div v-else-if="getError">{{ getError }}</div>
                    <div v-else>
                        <Multiselect :searchable="false" :show-labels="false" :allow-empty="false" label="name"
                            v-model="groupField" :options="groupsetData" :hideSelected="true" track-by="name">
                        </Multiselect>
                    </div>
                </div>
                <div class="d-flex flex-row w-100">
                    <div class="w-50">
                        <SearchItemComponent @selectedMusuemFunc="selectedMusuemFunc" :museumData="museumAllData"
                            :baseUrl="props.baseUrl" />
                    </div>
                    <div class="w-50 px-3">
                        <MuseumListComponent :selectedList="selectMuseums" @onMuseumOrderChange="onMuseumOrderChange" />
                    </div>
                </div>
            </div>
            <div>
                <LanguageComponent @handleLang="handleLang" @handleLabel="handleLabel" @handleModal="handleGoBack"
                    :uuid="props.editorId" :token="token" :languageJson="languageData" :baseUrl="props.baseUrl"
                    :itineraryTypesData="itineraryTypesData" />
            </div>
            <!-- Validate Modal -->
            <widget-container-modal />
        </div>
    </div>
</template>

<script>
import ButtonComponent from '../components/Button.vue';
import InputComponent from '../components/Input.vue';
import TextAreaComponent from '../components/TextArea.vue';
import ImgUploadComponent from '@/components/ImageUpload/ImgUploadComponent.vue';
import CheckerComponent from '../components/Checker.vue'
import SearchItemComponent from '../components/SearchItem.vue'
import LanguageComponent from '../components/Language.vue'
import MuseumListComponent from '../components/MuseumList.vue';
import ValidateModal from '../components/ValidateModal.vue';
import Multiselect from 'vue-multiselect';
import Loading from 'vue-loading-overlay';
import PremialitaComponent from '@/components/PremialitaComponent.vue';
import 'vue-loading-overlay/dist/css/index.css';
import {
    useToast
} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import {
    ref,
    onMounted,
    watch,
    onBeforeMount
} from 'vue';
import {
    container,
    openModal
} from "jenesius-vue-modal";
import axios from 'axios';

export default {
    name: 'EditRouteView',
    components: {
        ButtonComponent,
        InputComponent,
        TextAreaComponent,
        ImgUploadComponent,
        CheckerComponent,
        SearchItemComponent,
        LanguageComponent,
        MuseumListComponent,
        Multiselect,
        Loading,
        PremialitaComponent,
        WidgetContainerModal: container
    },
    props: {
        editorId: {
            type: String
        },
        router: {
            type: Object
        },
        baseUrl: {
            type: String
        },
        languageJson: {
            type: Array
        }
    },
    setup(props) {
        const groupsetData = ref([]);
        const isGroupsetFetch = ref(false);
        const editGroupset = ref('');
        const selectMuseums = ref([]);
        const groupField = ref({
            name: ''
        });
        const isLoading = ref(false);
        const getError = ref(null);
        const ticketRequired = ref(false);
        const markedPath = ref(false);
        const langCode = ref('it');
        const itinerariesEditData = ref([]);
        const museumAllData = ref([]);
        const imagesData = ref([]);
        const status = ref('');
        const validateText = ref([]);
        const cnt = ref(0);
        const itineraryTypesData = ref([]);
        const selItineraryTypesData = ref([]);
        const labelData = ref([]);

        const $toast = useToast();
        const router = ref(props.router);
        const token = ref('');
        // const baseUrl = 'https://ssot.laculturapremia.it/api';
        const totals = ref(0);
        const userRole = ref("visitor");
        const published = ref(0);
        const languageData = ref(props.languageJson.filter(val => !val.is_sign_language && !val.tours_only));

        const textVar = ref([]);
        const langIndexMap = {};
        const titleMap = {};
        const subtitleMap = {};
        const descriptionMap = {};
        const practicabilityMap = {};
        const durationMap = {};
        const activities = ref([])

        languageData.value.forEach((lang, index) => {
            const baseIndex = index * 5;

            textVar.value.push(
                { key: 'labels.title', value: '', languageCode: lang.lang_code },
                { key: 'labels.subtitle', value: '', languageCode: lang.lang_code },
                { key: 'labels.description', value: '', languageCode: lang.lang_code },
                { key: 'labels.practicability', value: '', languageCode: lang.lang_code },
                { key: 'labels.duration', value: '', languageCode: lang.lang_code }
            );

            langIndexMap[lang.lang_code] = {
                title: baseIndex,
                subtitle: baseIndex + 1,
                description: baseIndex + 2,
                practicability: baseIndex + 3,
                duration: baseIndex + 4
            };

            titleMap[lang.lang_code] = {
                title: 'Titolo',
                index: baseIndex,
                placeholder: 'Inserisci un titolo'
            };

            subtitleMap[lang.lang_code] = {
                title: 'Sottotitolo',
                index: baseIndex + 1,
                placeholder: 'Inserisci un sottotitolo'
            };

            descriptionMap[lang.lang_code] = {
                title: 'Descrizione',
                index: baseIndex + 2,
                placeholder: 'Inserisci una descrizione'
            };

            practicabilityMap[lang.lang_code] = {
                title: 'Praticabilità',
                index: baseIndex + 3,
                placeholder: 'Inserisci una praticabilità'
            };

            durationMap[lang.lang_code] = {
                title: 'Durata dell\'itinerario',
                index: baseIndex + 4,
                placeholder: 'Inserisci una durata'
            };
        });


        const fetchMuseums = async (groupset) => {
            isLoading.value = true;
            try {
                const response = await axios
                    .get(`${props.baseUrl}/v1.1/private/museums`, {
                        params: {
                            groupsetId: groupset.uuid
                        },
                        headers: {
                            Authorization: `Bearer ${token.value}`
                        }
                    });
                getError.value = null;
                museumAllData.value = response.data.results.map(val => ({
                    ...val,
                    flag: selectMuseums.value.map(item => item.uuid).includes(val.uuid)
                })).
                    sort((a, b) => {
                        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
                        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        // names must be equal
                        return 0;
                    });
            } catch (error) {
                getError.value = error;
                museumAllData.value = null;
            } finally {
                cnt.value = 2;
                isLoading.value = false;
            }
        };

        const fetchItinerariesTypes = async () => {
            isLoading.value = true;
            try {
                const response = await axios.get(`${props.baseUrl}/v1/public/itinerary-types`);
                getError.value = null;
                itineraryTypesData.value = response.data;
            } catch (error) {
                getError.value = error;
                itineraryTypesData.value = null;
            } finally {
                isLoading.value = false;
            }
        }

        const fetchDataById = async () => {
            isLoading.value = true;
            try {
                const response = await axios
                    .get(
                        `${props.baseUrl}/v1/private/itineraries/${props.editorId}`, {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token.value}`,
                        },
                    }
                    );
                getError.value = null;
                const data = response.data;

                editGroupset.value = data.groupset;
                selectMuseums.value = data.museums;
                itinerariesEditData.value = data;
                imagesData.value = data.images;
                groupField.value = data.groupset;
                ticketRequired.value = data.ticketRequired;
                markedPath.value = data.markedPath;
                activities.value = data.activities

                const updateTextVar = (key, lang, index) => {
                    const textField = data.textFields.find(val => val.key === key && val.languageCode.substring(0, 2) === lang);
                    textVar.value[index].value = textField ? textField.value : '';
                };

                if (data.textFields.length) {
                    languageData.value.map(val => val.lang_code).forEach(lang => {
                        const langMap = langIndexMap[lang];
                        Object.keys(langMap).forEach(field => {
                            updateTextVar(`labels.${field}`, lang, langMap[field]);
                        });
                    });
                }
                status.value = data.status.name;
                selItineraryTypesData.value = data.types;
            } catch (error) {
                getError.value = error;
                itinerariesEditData.value = null
            } finally {
                isLoading.value = false;
                cnt.value = 1;
            }
        };

        const fetchGroupset = async () => {
            isGroupsetFetch.value = true;
            try {
                const response = await axios.get(`${props.baseUrl}/v1.1/private/groupsets`, {
                    headers: {
                        Authorization: `Bearer ${token.value}`,
                    },
                });
                getError.value = null;
                groupsetData.value = response.data.results;
            } catch (error) {
                getError.value = error;
                groupsetData.value = null;
            } finally {
                isGroupsetFetch.value = false;
            }
        };

        const fetchUserInfo = async () => {
            isLoading.value = true;
            try {
                const response = await axios
                    .get(
                        `${props.baseUrl}/v1/users/me`, {
                        headers: {
                            Authorization: `Bearer ${token.value}`,
                        },
                    }
                    );
                getError.value = null;

                if (response.data.roles.admin) {
                    userRole.value = "admin";
                } else if (response.data.roles.curator) {
                    userRole.value = "curator";
                } else {
                    userRole.value = "visitor";
                }
            } catch (error) {
                getError.value = error;
                userRole.value = null;
            } finally {
                isLoading.value = false;
            }
        }

        const fetchData = async () => {
            isLoading.value = true;
            try {
                const response = await axios
                    .post(
                        `${props.baseUrl}/v1/private/itineraries/totals`, {}, {
                        headers: {
                            Authorization: `Bearer ${token.value}`,
                        },
                    }
                    );
                getError.value = null;
                switch (response.data.length) {
                    case 0:
                        totals.value = published.value = 0
                        break;
                    case 1:
                        totals.value = response.data[0].total;
                        response.data[0].status === "DRAFT" ? published.value = 0 : published.value = response.data[0].total
                        break;
                    default:
                        totals.value = response.data[0].total + response.data[1].total;
                        published.value = response.data.filter(val => val.status === 'PUBLISHED')[0].total;
                        break;
                }
            } catch (error) {
                getError.value = error;
                totals.value = published.value = null;
            } finally {
                isLoading.value = false;
            }
        };

        const selectedMusuemFunc = (selectedMuseums) => {
            selectMuseums.value = selectedMuseums.value;
        }

        const handleMarkedPath = (payload) => {
            markedPath.value = payload;
        }

        const handleTicket = (payload) => {
            ticketRequired.value = payload;
        }

        const handleTextUpdate = (payload, type) => {
            const index = langIndexMap[payload.lang][type];
            textVar.value[index] = {
                ...textVar.value[index],
                value: payload.text
            };
        };

        const handleTitle = (payload) => handleTextUpdate(payload, 'title');
        const handleSubTitle = (payload) => handleTextUpdate(payload, 'subtitle');
        const handleDescription = (payload) => handleTextUpdate(payload, 'description');
        const handlePracticability = (payload) => handleTextUpdate(payload, 'practicability');
        const handleDuration = (payload) => handleTextUpdate(payload, 'duration');

        const handleLang = (payload) => {
            langCode.value = languageData.value.find(val => val.name === payload).lang_code;
        }

        const isEmpty = (str) => {
            return (str === null || str === undefined || str.length <= 0) ? true : false;
        }

        const handleEdit = (statusVar) => {
            const requiredFields = languageData.value
                .filter(lang => lang.required)
                .flatMap(lang => [
                    { value: textVar.value[langIndexMap[lang.lang_code].title].value, label: `<b>Titolo in ${lang.name}</b>` },
                    { value: textVar.value[langIndexMap[lang.lang_code].description].value, label: `<b>Descrizione in ${lang.name}</b>` }
                ]);

            requiredFields.push(
                { value: imagesData.value, label: '<b>Immagini</b>' },
            );

            validateText.value = requiredFields
                .filter(field => isEmpty(field.value))
                .map(field => field.label);

            if (selectMuseums.value.length < 2) {
                validateText.value.push('<b>Musei</b>');
            }

            if (validateText.value.length > 0) {
                onShowModal();
                return false;
            }

            status.value = statusVar;
            axios.
                put(
                    `${props.baseUrl}/v1/private/itineraries/${props.editorId}`, {
                    status: statusVar,
                    name: textVar.value.find((text) => text.languageCode === "it" && text.key.includes("title"))?.value,
                    groupsetId: editGroupset.value.uuid,
                    textFields: [...textVar.value].map(val => ({
                        ...val
                    })),
                    images: [...imagesData.value].map(val => ({
                        ...val
                    }).uuid),
                    museums: [...selectMuseums.value].map(val => ({
                        ...val
                    }).uuid),
                    markedPath: markedPath.value,
                    ticketRequired: ticketRequired.value,
                    types: labelData.value.map(val => val.uuid)
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token.value}`,
                    },
                }
                ).
                then(() => {
                    $toast.success("L'itinerario è stato aggiornato con successo.", {
                        position: 'top-right'
                    })
                    router.value.push({
                        name: 'Itineraries'
                    });
                }).
                catch((err) => {
                    getError.value = err;
                })
            return true;
        }

        const onMuseumOrderChange = (payload) => {
            selectMuseums.value = payload;
        }

        const onShowModal = () => {
            openModal(ValidateModal, {
                modalTitle: 'Avvertimento',
                modalContent: validateText.value
            })
        }

        const handleUpload = (payload) => {
            imagesData.value = payload;
        }

        const handleLabel = (payload) => {
            labelData.value = payload;
        }

        const handleGoBack = () => {
            router.value.go(-1);
        }

        watch(isGroupsetFetch, newValue => {
            if (!newValue) fetchDataById()
        })

        watch(groupField, newValue => {
            editGroupset.value = newValue;
            fetchMuseums(newValue);
            if (cnt.value === 2) selectMuseums.value = [];
        })

        onBeforeMount(() => {
            console.log('editorId', props.editorId);
            const data = localStorage.getItem('mi_cms-tokens');
            if (data === null || data === undefined || data === '')
                return;
            else {
                token.value = JSON.parse(data).access;
            }
        })

        onMounted(() => {
            if (props.languageJson.length) {
                languageData.value = props.languageJson.filter(val => val.is_sign_language === false && val.tours_only === false);
            }
            fetchUserInfo();
            fetchData();
            fetchGroupset();
            fetchItinerariesTypes();
        })
        return {
            props,
            isLoading,
            getError,
            token,
            totals,
            userRole,
            published,
            selectMuseums,
            groupField,
            groupsetData,
            ticketRequired,
            markedPath,
            textVar,
            languageData,
            langIndexMap,
            titleMap,
            subtitleMap,
            descriptionMap,
            practicabilityMap,
            durationMap,
            itinerariesEditData,
            museumAllData,
            imagesData,
            langCode,
            status,
            validateText,
            itineraryTypesData,
            selItineraryTypesData,
            activities,
            selectedMusuemFunc,
            handleMarkedPath,
            handleTicket,
            handleTitle,
            handleSubTitle,
            handleDescription,
            handlePracticability,
            handleDuration,
            handleLang,
            handleUpload,
            handleEdit,
            handleLabel,
            onMuseumOrderChange,
            handleGoBack,
            fetchDataById
        }
    }
}
</script>

<style>
.gx-4px {
    gap: 4px;
}

.arrow-button {
    color: var(--neutrali-grigio-scuro, #4C4C4C);
    /* caption */
    font-family: Titillium Web;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    /* 171.429% */
}

.create-route-panel-body {
    display: flex;
    padding: 16px;
    align-items: flex-start;
    align-content: flex-start;
    flex-shrink: 0;
    flex-wrap: wrap;
    gap: 32px;
    border-radius: 8px;
    border: 1px solid var(--neutrali-grigio-segnaposto, #8F8F8F);
}

p.text-overview {
    text-align: left;
}

.flex-1 {
    flex: 1;
}

.premialita-text {
    color: var(--neutrali-grigio-scuro, #4C4C4C);
    font-family: Titillium Web;
    font-size: 13px;
    font-style: normal;
    line-height: 24px;
}

.premialita-input {
    color: var(--neutrali-grigio-scuro, #4C4C4C);
    background: #FFF;
    font-family: Titillium Web;
    font-style: normal;
    text-align: right;
    font-weight: 600;
    width: 100%;
    border: 0;
}

.disabled-state {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
}
</style>
